import { device } from '@helpers/mediaQueryBreakpoints'
import styled from 'styled-components'

interface MobileDeviceStyledProps {
    color: string
    stripeColor: string
    sensorsColor: string
    buttonsColor: string
    screenBorderColor: string
}

export const MobileDevice = styled.div`
    .device,
    .device * {
        &,
        &::before,
        &::after {
            box-sizing: border-box;
            display: flex;
        }
    }

    .device-frame {
        background: ${(props: MobileDeviceStyledProps) => props?.color || 'white'};
        border-radius: 68px;
        box-shadow: ${(props: MobileDeviceStyledProps) =>
            `inset 0 0 0 2px ${props?.buttonsColor}, inset 0 0 0 7px ${props?.stripeColor}`};
        height: 871px;
        padding: 102px 22px;
        width: 419px;

        @media ${device.xs} {
            background: unset;
            border-radius: unset;
            box-shadow: unset;
        }
    }

    .device-screen {
        border: ${(props: MobileDeviceStyledProps) => `2px solid ${props?.screenBorderColor}`};
        border-radius: 4px;
        height: 667px;
        width: 375px;

        @media ${device.xs} {
            transform: scale(1.3);
            border: unset;
            border-radius: unset;
            box-shadow: ${(props: MobileDeviceStyledProps) => `10px 10px 10px ${props?.buttonsColor}`};
        }
    }

    .device-stripe {
        &::after,
        &::before {
            border: ${(props: MobileDeviceStyledProps) => `solid ${props?.buttonsColor}`};
            border-width: 0 7px;
            content: '';
            height: 6px;
            left: 0;
            position: absolute;
            width: 100%;
            z-index: 9;
        }
        &::after {
            top: 68px;
        }
        &::before {
            bottom: 68px;
        }

        @media ${device.xs} {
            display: none;
        }
    }

    .device-home {
        border: ${(props: MobileDeviceStyledProps) => `2px solid ${props?.buttonsColor}`};
        border-radius: 50%;
        bottom: 25px;
        height: 58px;
        left: 50%;
        margin-left: -29px;
        position: absolute;
        width: 58px;

        @media ${device.xs} {
            display: none;
        }
    }

    .device-sensors {
        background: ${(props: MobileDeviceStyledProps) => props?.sensorsColor};
        border-radius: 3px;
        height: 6px;
        left: 50%;
        margin-left: -38px;
        position: absolute;
        top: 52px;
        width: 76px;

        &::after,
        &::before {
            background: ${(props: MobileDeviceStyledProps) => props?.sensorsColor};
            border-radius: 50%;
            content: '';
            position: absolute;
        }
        &::after {
            height: 10px;
            left: 50%;
            margin-left: -5px;
            top: -25px;
            width: 10px;
        }
        &::before {
            height: 12px;
            left: -42px;
            margin-top: -6px;
            top: 50%;
            width: 12px;
        }

        @media ${device.xs} {
            display: none;
        }
    }

    .device-btns {
        background: ${(props: MobileDeviceStyledProps) => props?.buttonsColor};
        height: 30px;
        left: -3px;
        position: absolute;
        top: 102px;
        width: 3px;

        &::after,
        &::before {
            background: ${(props: MobileDeviceStyledProps) => props?.buttonsColor};
            content: '';
            height: 56px;
            left: 0;
            position: absolute;
            width: 3px;
        }

        &::after {
            top: 62px;
        }
        &::before {
            top: 132px;
        }

        @media ${device.xs} {
            display: none;
        }
    }

    .device-power {
        background: ${(props: MobileDeviceStyledProps) => props?.buttonsColor};
        height: 80px;
        right: -2px;
        position: absolute;
        top: 160px;
        width: 3px;

        @media ${device.xs} {
            display: none;
        }
    }
`
